import { AnalyticsDashboard } from '@/components/module/analytics/AnalyticsDashboard';
import { DashboardPageWrap } from './style';

/**
 * Tenant home: analytics dashboard (charts via Recharts; layout data from useAnalyticsDashboardLayout).
 */
const Dashboard = () => {
    return (
        <DashboardPageWrap>
            <AnalyticsDashboard />
        </DashboardPageWrap>
    );
};

export default Dashboard;
